import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const Login = () => {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <Loader2 className="animate-spin text-zinc-400" size={28} />
      </div>
    );
  }
  if (user) return <Navigate to="/admin/pages" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      navigate("/admin/pages", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-white border border-zinc-200 rounded-lg p-10">
        <p className="text-[10px] tracking-[0.3em] text-zinc-400 uppercase">Millpond CMS</p>
        <h1 className="text-2xl font-medium text-zinc-900 mt-2">Sign in</h1>
        <p className="text-sm text-zinc-500 mt-1">Admin access only.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="text-xs text-zinc-600 tracking-wide">Username</label>
            <input
              data-testid="admin-login-username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 w-full px-3 py-2.5 border border-zinc-300 rounded-md focus:outline-none focus:border-zinc-900 text-sm"
              required
            />
          </div>
          <div>
            <label className="text-xs text-zinc-600 tracking-wide">Password</label>
            <input
              data-testid="admin-login-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2.5 border border-zinc-300 rounded-md focus:outline-none focus:border-zinc-900 text-sm"
              required
            />
          </div>

          {error && (
            <div data-testid="admin-login-error" className="text-xs text-red-600 bg-red-50 border border-red-100 rounded px-3 py-2">
              {error}
            </div>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={submitting}
            className="w-full bg-zinc-900 text-white text-sm tracking-wide py-2.5 rounded-md hover:bg-zinc-800 transition disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {submitting && <Loader2 size={14} className="animate-spin" />}
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
